import dynamic from "next/dynamic";

export const DynamicContentBookmark = dynamic(() =>
  import("~/components/content/content-bookmark").then(module => module.ContentBookmark),
);
